import React, { useState, useEffect } from "react";
import { IoIosClose } from "react-icons/io";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useForm } from "react-hook-form";
import RequestService from "../../services/RequestService";
import MinorRequestDetails from './../molecules/MinorRequestDetails';
import { parseISO, format } from "date-fns";
import StatusRequests from '../../enums/StatusRequests'
import { MdSend } from "react-icons/md";
import { FaStamp } from 'react-icons/fa';

export default function DeliverModal({
  isModalOpen,
  setModalOpen,
  requestId,
  requestNro
  // setTicketCb
}) {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const [requestObject, setRequestObject] = useState();
  const [usarDoc, setUsarDoc] = useState(false);

  const handleUsarDocChange = (event) => {
    setUsarDoc(event.target.checked);
  };

  const [atualizadoSGRS, setAtualizadoSGRS] = useState(false);

  const handleAtualizadoSGRSChange = (event) => {
    setAtualizadoSGRS(event.target.checked);
  };

  useEffect(() => {
    async function fetchRequest() {
      const request = await RequestService.getRequestById(requestId);
      setRequestObject(request);
      console.log(request?.request.idRequest);
    }

    fetchRequest();
  }, [isModalOpen, requestId]);

  const onSubmit = async (data) => {
    console.log(data);

    data = { 
      ...data, 
      status: "ENTREGUE", 
    };

    const response = await RequestService.sendToDelivery(requestId, data);

    if (response) {
      toast.success("Pedido entregue!");
    } else {
      // console.log(error)
      toast.error("Ops! Algo deu errado");
    }

    setModalOpen(!isModalOpen);
    reset();
  };

  const onClose = () => {
    setModalOpen(!isModalOpen);
    reset();
  };

  if (isModalOpen) {
    return (
      <div
        className="flex flex-col relative z-10"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto py-8"
          onClick={onClose}
        >
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <div className="flex flex-col max-w-[700px] h-fit pb-4 relative transform rounded-lg bg-white text-left shadow-xl transition-all" onClick={(e) => e.stopPropagation()}>
              <button
                onClick={onClose}
                className="absolute -top-7 -right-7 rounded-full p-1"
              >
                <div className="w-12 h-12 flex bg-gray-200 justify-center items-center rounded-full ms-6">
                  <div className="flex justify-center items-center">
                    <IoIosClose color={"black"} size={32} />
                  </div>
                </div>
              </button>
              <div className="flex flex-col px-4 pt-4 pb-3 text-left gap-2 bg-gray-800 text-white rounded-t-lg">

                <div className="flex justify-between gap-2">
                  <div className="flex gap-2 items-center text-white text-xl font-bold">
                    <MdSend />
                    REGISTRAR ENTREGA
                  </div>

                  {requestObject?.request?.isReplica &&
                    <div>
                      <p className="text-black font-bold rounded-lg px-1 bg-yellow-300">
                        RÉPLICA SGRS
                      </p>
                    </div>
                  }
                </div>

                <div className="ms-4 flex justify-between">
                  <div className="text-sm">
                    Solicitação nº: {requestObject?.request?.idRequest}
                  </div>
                  <div className="text-sm">
                    {/* Criado em: {requestObject?.request?.createdAt } */}
                    Criado em: {requestObject && format(parseISO(requestObject?.request?.createdAt), 'dd/MM/yy HH:mm')}
                  </div>
                  <div className="flex items-center gap-2">
                    Status:
                    <p  className="text-sm text-black rounded-lg px-2"
                        style={{ backgroundColor: StatusRequests[requestObject?.request?.status]?.cor }}>
                      {requestObject?.request?.status}
                    </p>
                  </div>
                </div>
              </div>

              <MinorRequestDetails request={requestObject?.request} divContato={true} />

              {/* MODAL FORM BEGIN */}

              <div className="flex flex-col mt-6 px-4 text-xs">
                <div className="w-full relative inline-block text-left">
                  <div className="w-full flex flex-col gap-2 px-4">

                    <div className="flex gap-2">
                      <div className="flex flex-col items-start gap-1 w-full">
                        <label className="w-1/5 block text-gray-700 font-bold whitespace-nowrap">
                          Recebido por:
                        </label>                      
                        <input
                          type="text"
                          {...register("recebidoPor", { required: true })}
                          className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                              ${
                                errors?.recebidoPor?.type === "required"
                                  ? " border border-red-500 outline-none ring-0"
                                  : "border border-zinc-500 outline-none ring-0"
                              }
                              `}
                        />
                        {errors?.recebidoPor?.type === "required" && (
                          <p className="text-red-500 text-xs ms-2">
                            Campo obrigatório
                          </p>
                        )}
                      </div>

                      {/* <div className="flex flex-col items-start gap-1 w-full">
                        <label className="w-1/5 block text-gray-700 font-bold whitespace-nowrap">
                          Data e Hora do Recebimento:
                        </label>
                        <input
                          {...register("dataHoraRecebimento", { required: true })}
                          type="datetime-local"
                          placeholder="Start Date and Time"
                          className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                              ${
                                errors?.dataHoraRecebimento?.type === "required"
                                  ? " border border-red-500 outline-none ring-0"
                                  : "border border-zinc-500 outline-none ring-0"
                              }
                              `}
                        />                      
                        {errors?.dataHoraRecebimento?.type === "required" && (
                          <p className="text-red-500 text-xs ms-2">
                            Campo obrigatório
                          </p>
                        )}
                      </div> */}
                      
                      <div className="flex flex-col items-start gap-1 w-full">
                        <div className="flex w-full justify-between">
                          <label className="block text-gray-700 font-bold whitespace-nowrap">
                            Matrícula Recebedor:
                          </label>
                          <div className="flex gap-2">
                            <label className="text-gray-700 whitespace-nowrap">
                              Usar Doc
                            </label>
                            <input
                              id="usarDoc"
                              type="checkbox"
                              checked={usarDoc}
                              onChange={handleUsarDocChange}
                              className="form-checkbox h-4 w-4 text-blue-600"
                            />
                          </div>
                        </div>
                        <input
                          disabled={usarDoc ? 'true' : ''}
                          type="text"
                          {...register("matriculaRecebedor", {
                            required: usarDoc ? false : true,
                          })}
                          className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400 disabled:bg-gray-200
                        ${errors?.matriculaRecebedor?.type === "required"
                              ? " border border-red-500 outline-none ring-0"
                              : "border border-zinc-500 outline-none ring-0"
                            }
                        `}
                        />
                        {errors?.matriculaRecebedor?.type === "required" && (
                          <p className="text-red-500 text-xs ms-2">
                            Campo obrigatório
                          </p>
                        )}
                      </div>

                      {usarDoc &&
                        <div className="flex flex-col items-start gap-1 w-full">
                          <label className="w-1/5 block text-gray-700 font-bold whitespace-nowrap">
                            Nº do Documento do Recebedor:
                          </label>
                          <input
                            type="text"
                            {...register("docRecebedor", { required: true })}
                            className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                              ${errors?.docRecebedor?.type === "required"
                                ? " border border-red-500 outline-none ring-0"
                                : "border border-zinc-500 outline-none ring-0"
                              }
                              `}
                          />
                          {errors?.docRecebedor?.type === "required" && (
                            <p className="text-red-500 text-xs ms-2">
                              Campo obrigatório
                            </p>
                          )}
                        </div>
                      }

                    </div>

                    
                    
                    <div className="flex flex-row gap-2 w-full">
                    
                    <div className="flex flex-col items-start gap-1 mb-4 w-full">
                      <label className="w-1/5 block text-gray-700 font-bold whitespace-nowrap">Observação:</label>
                      <textarea
                        {...register("obsAtualizacao", { required: true })}
                        className={`
                              w-full h-[70px] p-4 bg-white rounded-2xl justify-start items-center inline-flex resize-none 
                              text-neutral-600 font-normal font-['Work Sans']
                              focus:border focus:border-zinc-800 focus:outline-none focus:ring-0
                              placeholder:text-neutral-400 placeholder:font-normal
                              ${
                                errors?.obsAtualizacao?.type === "required" ?
                                "border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"
                          }
                          `}
                        placeholder={"Observação"}>
                      </textarea>
                      {errors?.obsAtualizacao?.type === "required" && (
                        <p className="text-red-500 text-xs whitespace-nowrap">
                          Campo obrigatório
                        </p>
                      )}
                    </div>
                    {/* <div className="flex flex-col items-start gap-1 mb-4 w-full">
                      <div className="flex gap-1 text-gray-700">
                        <FaStamp />
                        <label className="w-1/5 block text-gray-700 font-bold whitespace-nowrap">Carimbo:</label>
                      </div>
                      <textarea
                        {...register("carimbo", { 
                          // required: true 
                        })}
                        className={`
                              w-full h-[70px] p-4 bg-white rounded-2xl justify-start items-center inline-flex resize-none 
                              text-neutral-600 font-normal font-['Work Sans']
                              focus:border focus:border-zinc-800 focus:outline-none focus:ring-0
                              placeholder:text-neutral-400 placeholder:font-normal
                              ${
                                errors?.carimbo?.type === "required" ?
                                "border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"
                          }
                          `}
                        placeholder={"Observação"}>
                      </textarea>
                      {errors?.carimbo?.type === "required" && (
                        <p className="text-red-500 text-xs whitespace-nowrap">
                          Campo obrigatório
                        </p>
                      )}
                    </div> */}

                  </div>

                  {requestObject?.request?.isReplica &&
                      <div className="flex gap-2">
                        <input
                          type="checkbox"
                          checked={atualizadoSGRS}
                          onChange={handleAtualizadoSGRSChange}
                          className="form-checkbox h-4 w-4 text-blue-600"
                        />
                        <label className="text-gray-700 font-bold whitespace-nowrap">
                          Confirmo que já atualizei no SGRS
                        </label>
                      </div>
                    }

                    <button
                      disabled={!requestObject?.request?.isReplica ? false : atualizadoSGRS ? false : true}
                      onClick={() => handleSubmit(onSubmit)()}
                      className="w-full bg-blue-500 text-white py-2 px-4 rounded-2xl hover:bg-blue-600 mt-2 disabled:bg-gray-200"
                    >
                      Enviar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
